import React, { useEffect } from 'react';
import { Card, Col, Form, Row, Button } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import moment from "moment";
import axios from 'helpers/api';
import { toast } from 'react-toastify';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import Spinner from 'react-bootstrap/Spinner';

const columns = [
    {
        accessorKey: 'month',
        header: 'Report Date',
        meta: {
            headerProps: { className: 'text-900 text-start' },
            cellProps: { className: 'text-start' }
        }
    },
    {
        accessorKey: 'download',
        header: 'Report Download',
        meta: {
            headerProps: { className: 'text-900 text-start' },
            cellProps: { className: 'text-start' }
        }
    }
];

//const [medsheet, setMedSheet] = useState([]);

const BlankMedsheet = (props) => {
    const [reportFormat, setReportFormat] = useState(localStorage.getItem('medsheetFormat') || '0');
    const [treatmentrpt, setTreatment] = useState("");
    const [spinner, showSpinner] = useState(false);
    const [reportDateError, setReportDateError] = useState(false);
    const [reportFormatError, setReportFormatError] = useState(false);
    const [formData, setFormData] = useState({
        reportdate: '',
        reportformat: '',
        is_drug_hcp: '',
        is_prn: true,
        is_regular: true
    });

    const [reportdate, setReportDate] = useState(null);
    const [showResults, setShowResults] = React.useState(false)
    useEffect(() => {
        if (spinner) {
            setShowResults(false);
        }
    }, [spinner])

    const handleSubmit = async e => {
        e.preventDefault();
        if (!props.validateFacility()) return;
        const dateValid = reportdate !== null;
        const formatValid = reportFormat != '0';

        setReportDateError(!dateValid);
        setReportFormatError(!formatValid);

        if (!dateValid || !formatValid) {
            return;
        }
        if ((localStorage.getItem("patientId") != null || localStorage.getItem("reportFacilityId") != null) && reportFormat != "" && reportdate != null) {

            showSpinner(true);

            let tokenStr = localStorage.getItem("accessToken");
            let pelmedsTreatmentUrl = `${process.env.REACT_APP_SERVER_URL}` + "/reports/medsheet-blank";

            let pelmedsTreatmentData = {
                date: moment(reportdate).format('MMM YYYY'),
                facility_id: localStorage.getItem("reportFacilityId"),
                medsheet_format: reportFormat,
            };
            const { data } = await axios.post(pelmedsTreatmentUrl, pelmedsTreatmentData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

            console.log("data " + JSON.stringify(data));

            if (data.status) {

                setTreatment(data.medsheet_url);
                setShowResults(true);

                //console.log(JSON.stringify(treatmentrpt));

                toast.success("Treatment Report Generated Successfully");
            }
            else {
                toast.error(data.message);
            }
            showSpinner(false);
        }
        else {
            toast.error("Required Fields are empty");
        }


    };

    const handleFieldChange = (e) => {
        const { name, value } = e.target;
      
        if (name === "reportformat") {
          setReportFormat(value);
        }
        setShowResults(false);
        setFormData((prev) => ({
          ...prev,
          [name]: value
        }));
      };

    return (
        <div>
            <Form onSubmit={handleSubmit}>
                <Row>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label className="required">Report Date</Form.Label>
                            <DatePicker name="reportdate" selected={reportdate} onChange={(reportdate) => setReportDate(reportdate)}
                                dateFormat="MMM yyyy" showMonthYearPicker className='form-control form-control-sm' placeholderText="Select Report Date" />
                                {reportDateError && <div className="invalid-feedback">Report date is required</div>}
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label className="required">Report Format</Form.Label>
                            <Form.Select name="reportformat"
                                onChange={handleFieldChange}
                                value={reportFormat}
                                disabled = {localStorage.getItem("medsheetFormat") !== "0"}
                                size="sm">
                                <option value='0'>Select your Format</option>
                                <option value='1'>1</option>
                                <option value='2'>2</option>
                                <option value='3'>3</option>
                                <option value='4'>4</option>
                                <option value='7'>7</option>
                                <option value='8'>8</option>
                                <option value='9'>9</option>
                                <option value='10'>10</option>
                                 <option value='11'>11</option>
                            </Form.Select>
                            {reportFormatError && <div className="invalid-feedback">Report format is required</div>}
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col></Col>
                    <Col>
                        <Form.Group>
                            {spinner && (
                                <Button variant="primary" disabled className="mt-3 w-100">
                                    <Spinner
                                        as="span"
                                        animation="grow"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    <span className="p-2" style={{ "verticalAlign": "3px" }}>Fetching...</span>
                                </Button>
                            )}
                            {!spinner && (
                                <Button
                                    type="submit"
                                    color="primary"
                                    className="mt-3 w-100">
                                    Get Medsheet
                                </Button>
                            )}
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Label><span className="text-danger">*</span> indicates required field</Form.Label>
                    </Col>
                </Row>
            </Form>
            <br />
            {showResults && (
                <a href={treatmentrpt} target="_blank" rel="noreferrer">
                    <button className="btn btn-primary">
                        📄 Download Report
                    </button>
                </a>
            )}
        </div>
    );
};

BlankMedsheet.propTypes = {
    layout: PropTypes.string,
    hasLabel: PropTypes.bool
};

BlankMedsheet.defaultProps = {
    layout: 'simple',
    hasLabel: false
};

export default BlankMedsheet;

